import {Category} from "dto/category/category"
import LocationCategoryForm, {CategoryInput} from "pages/admin/category/form/LocationCategoryForm"
import {useUpdateCategoryMutation} from "hooks/queries/category.query"
import {AxiosError} from "axios"

type Props = {
    category: Category | undefined
    close: () => void
}
export default function UpdateCategory({category, close}: Props) {
    const updateCategory = useUpdateCategoryMutation()
    if(category === undefined) {
        window.alert("카테고리를 선택해주세요.")
        return (<div></div>)
    }

    const onSubmit = (value: CategoryInput) => {
        const ctg: Category = {
            id: category.id,
            name: value.name,
            level: category.level,
            parentId: category.parentId,
            contactManager: value.contactManager,
        }
        updateCategory.mutate(ctg, {
            onSuccess: (data, variables, context) => {
                console.log("success value : ", data, variables, context)
                close()
            },
            onError: (err, variables, context) => {
                const error = (err as AxiosError)
                console.log("error value : ", error, variables, context)
            }
        })
    }
    return (
        <LocationCategoryForm category={category} show={true} close={() => close()} onSubmit={onSubmit}/>
    )
}